import { Component, computed, inject, input } from '@angular/core';
import { TranslateService } from '@devinforius/i-essentials';
import { STATUS_COLORS_PALETTE } from '@shared/constants/status-colors-palette';
import { MandateStatus } from '@shared/types/mandate-state.type';

@Component({
  selector: 'im-mandate-status-chip',
  templateUrl: './mandate-status-chip.component.html',
  styleUrl: './mandate-status-chip.component.scss',
})
export class MandateStatusChipComponent {
  private readonly translater = inject(TranslateService);
  public readonly status = input.required<MandateStatus>();
  public readonly statusColorsPalette = STATUS_COLORS_PALETTE;
  public readonly statusLabel = computed<string>(() => {
    switch (this.status()) {
      case 'pending confirmation':
        return this.translater.instant(
          'PRIVATE.MANDATES.DETAILS.STATUSES.TO_COMPLETE',
        );
      case 'confirmed':
        return this.translater.instant(
          'PRIVATE.MANDATES.DETAILS.STATUSES.CONFIRMED',
        );
      case 'pending signature':
        return this.translater.instant(
          'PRIVATE.MANDATES.DETAILS.STATUSES.WAITING_FOR_SIGNATURE',
        );
      case 'signed':
        return this.translater.instant(
          'PRIVATE.MANDATES.DETAILS.STATUSES.SIGNED',
        );
      case 'refused':
        return this.translater.instant(
          'PRIVATE.MANDATES.DETAILS.STATUSES.REFUSED',
        );
    }
  });
}
